import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const OwnedMediaDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.owned9-16_svg__cls-1{fill:#fff}'}</style>
    </defs>
    <g id="owned9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="owned9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="owned9-16_svg__cls-1"
          d="M124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v257.6a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V21.64A14.31 14.31 0 00124 7.33z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path
          className="owned9-16_svg__cls-1"
          d="M138.29 21.64A14.31 14.31 0 00124 7.33h-14.14v1.92a7.59 7.59 0 01-7.59 7.59H43.16a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.3 21.64v225.17h132V39.65z"
        />
        <path transform="rotate(90 72.31 149.2)" fill="#424242" d="M-46.76 83.21h238.13v131.98H-46.76z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default OwnedMediaDevice916;
